module.exports = __webpack_public_path__ + "img/login-bg.3c0b668a.jpg";